module.exports = "https://cdn-skillquest.mathletics.com/app/195/assets/images/1232bb6d97fa8c16f3c7257418860782.svg";